const TAO_KOE = window.TAO_KOE || {};
export default TAO_KOE;
